

const SortIcon = ({ className }) => {
    return (
        <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.52344 11.6364V3.04968" stroke="#212121" strokeWidth="0.933333" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M10.3789 11.6364V3.04968" stroke="#212121" strokeWidth="0.933333" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M3.4707 4.73119L5.52404 2.67786L7.57737 4.73119" stroke="#212121" strokeWidth="0.933333" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M12.4289 9.58301L10.3756 11.6363L8.32227 9.58301" stroke="#212121" strokeWidth="0.933333" strokeLinecap="round" strokeLinejoin="round" />
            <defs>
                <clipPath id="clip0_41_44496">
                    <rect width="14" height="14" fill="white" transform="translate(0.951172 0.00305176)" />
                </clipPath>
                <clipPath id="clip1_41_44496">
                    <rect width="14" height="14" fill="white" transform="translate(0.951172 0.00305176)" />
                </clipPath>
            </defs>
        </svg>

    )
}

export default SortIcon